'use client';
import { memo, useCallback, useState } from 'react';
import { Grid, Stack, VStack } from '@chakra-ui/react';

import BlockHeader from 'shared/BlockHeader';
import Switcher from 'shared/Switcher';
import { ym } from 'shared/lib';

import { multiTabsCardsBlockPropsSelector } from 'constants/MultiTabsCardsBlock';

const MultiTabsCardsBlock = ({ type }) => {
  const {
    title = null,
    titleProps = null,
    labels,
    tabsData,
    CardComponent,
    gridProps = null,
    metricNameOnSwitcherClick = null,
    RenderBottom = null,
  } = multiTabsCardsBlockPropsSelector[type];
  const [activeLabel, setActiveLabel] = useState(labels[0]);

  const handleLabelClick = useCallback(newLabel => {
    setActiveLabel(newLabel);
    metricNameOnSwitcherClick && ym(metricNameOnSwitcherClick);
  }, []);

  return (
    <VStack as="section" w="full" align="start" gap={{ laptop: '48px', mobile: '32px' }}>
      <BlockHeader {...titleProps}>
        {title ?? (
          <>
            Навыки и компетенции
            <br /> наших специалистов
          </>
        )}
      </BlockHeader>

      <Stack w="full" gap={{ laptop: '28px', mobile: '20px' }}>
        <Switcher
          uniqueId="multiTabsCardsBlockSwitcher"
          labels={labels}
          activeLabel={activeLabel}
          onLabelClick={handleLabelClick}
        />

        <Grid
          w="full"
          gridTemplateColumns={{ tablet: '1fr 1fr' }}
          gap={{ laptop: '20px', mobile: '16px' }}
          {...gridProps}
        >
          {tabsData[activeLabel].map((data, i) => (
            <CardComponent key={`${data.title}-${i}`} {...data} />
          ))}
        </Grid>
      </Stack>

      {RenderBottom}
    </VStack>
  );
};

export default memo(MultiTabsCardsBlock);
